import { http, HttpResponse } from 'msw'

import { allRefills } from '@/mocks/data/transactions/refills'

import { isNumeric } from '@/utils/app/number'
import { api } from '@/utils/constants'

import { RefillsRequest } from '@/types/transactions/refill'

export const getAllRefills = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.REFILL_HISTORY}`,
    ({ request }) => {
        const url = new URL(request.url)

        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray = Math.min(allRefills.length, offset + limit)
        const results = allRefills.slice(offset, limitArray)

        const next =
            offset + results.length < allRefills.length ? 'again' : undefined

        return HttpResponse.json<RefillsRequest>({
            next,
            results,
        })
    },
)
